import { useRecruiterBookingFlowContext } from "../../hooks/useRecruiterBookingFlowContext";
import { RecruiterScreeningCallMeNowConfirmationContent } from "./RecruiterScreeningCallMeNowConfirmationContent";
import { RecruiterScreeningCallMeNowContactContent } from "./RecruiterScreeningCallMeNowContactContent";

export function RecruiterScreeningCallMeNowContent() {
  const { stage } = useRecruiterBookingFlowContext();

  switch (stage) {
    case "contact-details": {
      return <RecruiterScreeningCallMeNowContactContent />;
    }

    case "confirmation": {
      return <RecruiterScreeningCallMeNowConfirmationContent />;
    }

    default: {
      return null;
    }
  }
}
